/* My Event Lab — renders the product prototypes (template + logic) with Preact and adds Shopify basket support */
(function () {
  'use strict';

  /* ---------- logic base class (matches the prototype API) ---------- */
  function DCLogic(props) { this.props = props || {}; this.state = {}; }
  DCLogic.prototype.setState = function (u, cb) {
    var patch = typeof u === 'function' ? u(this.state) : u;
    var done = typeof cb === 'function' ? cb.bind(this) : null;
    if (!patch) { if (done) done(); return; }
    var next = {}, k;
    for (k in this.state) next[k] = this.state[k];
    for (k in patch) next[k] = patch[k];
    this.state = next;
    if (this.__host) this.__host.forceUpdate(done || undefined); else if (done) done();
  };

  /* ---------- template compiler ---------- */
  var WHOLE = /^\{\{\s*([\w$.]+)\s*\}\}$/;
  var PART = /\{\{\s*([\w$.]+)\s*\}\}/g;
  var BOOL = { multiple: 1, disabled: 1, checked: 1, readonly: 1, required: 1, hidden: 1, selected: 1, autofocus: 1, open: 1 };
  var TEXTISH = { text: 1, number: 1, range: 1, color: 1, search: 1, email: 1, tel: 1, url: 1, password: 1, '': 1 };

  function lookup(scope, path) {
    var parts = path.split('.'), head = parts[0], s = scope, v;
    while (s) { if (s.vars && Object.prototype.hasOwnProperty.call(s.vars, head)) { v = s.vars[head]; break; } s = s.parent; }
    for (var i = 1; i < parts.length; i++) { if (v == null) return undefined; v = v[parts[i]]; }
    return v;
  }
  function interp(str, scope) {
    return str.replace(PART, function (_, p) { var v = lookup(scope, p); return v == null ? '' : String(v); });
  }
  function valueFn(raw) {
    var m = raw.match(WHOLE);
    if (m) { var p = m[1]; return function (sc) { return lookup(sc, p); }; }
    if (raw.indexOf('{{') > -1) return function (sc) { return interp(raw, sc); };
    return function () { return raw; };
  }

  function compileChildren(nodes) {
    var out = [];
    for (var i = 0; i < nodes.length; i++) { var c = compileNode(nodes[i]); if (c) out.push(c); }
    return function (scope) {
      var res = [];
      for (var j = 0; j < out.length; j++) { var r = out[j](scope); if (r == null || r === false) continue; if (Array.isArray(r)) Array.prototype.push.apply(res, r); else res.push(r); }
      return res;
    };
  }

  function compileNode(node) {
    var h = window.preact.h;
    if (node.nodeType === 3) {
      var t = node.nodeValue;
      if (/\n/.test(t)) { t = t.replace(/^\s*\n\s*/, '').replace(/\s*\n\s*$/, ''); if (!t.trim()) return null; t = t.replace(/\s*\n\s*/g, ' '); }
      if (t.indexOf('{{') < 0) return function () { return t; };
      return function (sc) { return interp(t, sc); };
    }
    if (node.nodeType !== 1) return null;
    var tag = node.localName;
    if (tag === 'sc-if') {
      var cond = valueFn(node.getAttribute('value') || ''), kidsIf = compileChildren(node.childNodes);
      return function (sc) { return cond(sc) ? kidsIf(sc) : null; };
    }
    if (tag === 'sc-for') {
      var list = valueFn(node.getAttribute('list') || ''), as = node.getAttribute('as') || 'item', kidsFor = compileChildren(node.childNodes);
      return function (sc) {
        var arr = list(sc) || [], res = [];
        for (var i = 0; i < arr.length; i++) { var v = {}; v[as] = arr[i]; var r = kidsFor({ vars: v, parent: sc }); Array.prototype.push.apply(res, r); }
        return res;
      };
    }
    var type = (node.getAttribute('type') || '').toLowerCase();
    var textish = (tag === 'input' && TEXTISH[type]) || tag === 'textarea';
    var props = [];
    for (var a = 0; a < node.attributes.length; a++) {
      var at = node.attributes[a], name = at.name, raw = at.value;
      if (name.indexOf('hint-') === 0) continue;
      var lname = name.toLowerCase();
      if (lname.indexOf('on') === 0) {
        if (lname === 'onchange' && textish) name = 'oninput';
        else name = lname;
      }
      if (BOOL[lname] && raw === '') { props.push([name, function () { return true; }]); continue; }
      props.push([name, valueFn(raw)]);
    }
    var kids;
    if (tag === 'textarea') {
      var txt = valueFn(node.textContent || '');
      props.push(['value', txt]);
      kids = function () { return []; };
    } else {
      kids = compileChildren((tag === 'template' ? node.content : node).childNodes);
    }
    return function (sc) {
      var p = {};
      for (var i = 0; i < props.length; i++) {
        var v = props[i][1](sc);
        if (v === undefined) continue;
        p[props[i][0]] = v;
      }
      var c = kids(sc);
      return h.apply(null, [tag, p].concat(c));
    };
  }

  function compile(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    return compileChildren(tpl.content.childNodes);
  }

  /* ---------- host component ---------- */
  function mount(el, Logic, tplHtml, props) {
    var P = window.preact, render = compile(tplHtml);
    function Host() { P.Component.call(this); this.logic = new Logic(props || {}); this.logic.__host = this; window.MelDC.instance = this.logic; }
    Host.prototype = Object.create(P.Component.prototype);
    Host.prototype.constructor = Host;
    Host.prototype.render = function () {
      var vals = this.logic.renderVals();
      return P.h(P.Fragment, null, render({ vars: vals, parent: null }));
    };
    Host.prototype.componentDidMount = function () { if (this.logic.componentDidMount) this.logic.componentDidMount(); };
    Host.prototype.componentDidUpdate = function () { if (this.logic.componentDidUpdate) this.logic.componentDidUpdate(); };
    Host.prototype.componentWillUnmount = function () { if (this.logic.componentWillUnmount) this.logic.componentWillUnmount(); };
    el.innerHTML = '';
    P.render(P.h(Host), el);
    return el;
  }

  /* ---------- Shopify helpers ---------- */
  var files = {};
  function captureFiles(root) {
    // keep the actual File objects (some prototype handlers clear the input after reading)
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.type === 'file' && t.files && t.files.length) {
        var key = t.id || t.name || 'file';
        files[key] = (t.multiple ? (files[key] || []) : []).concat(Array.prototype.slice.call(t.files)).slice(-6);
      }
    }, true);
  }
  function money(cents) { var v = cents / 100; return '£' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }
  function findVariant(product, opts) {
    var vs = product.variants;
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var j = 0; j < opts.length; j++) if (opts[j] != null && vs[i].options[j] !== opts[j]) { ok = false; break; }
      if (ok) return vs[i];
    }
    return null;
  }
  function addonVariant(addon, title) {
    if (!addon || !addon.variants || !addon.variants.length) return null;
    if (title == null) return addon.variants[0];
    for (var i = 0; i < addon.variants.length; i++) if (addon.variants[i].title === title) return addon.variants[i];
    return null;
  }
  /* order = { variant, properties: {k:v}, files: {propName: [File]}, addons: [{variant, label}] } */
  function addToCart(order, cartUrl) {
    var ref = 'MEL-' + Date.now().toString(36).toUpperCase();
    var fd = new FormData();
    fd.append('id', order.variant.id);
    fd.append('quantity', 1);
    Object.keys(order.properties || {}).forEach(function (k) { var v = order.properties[k]; if (v !== '' && v != null) fd.append('properties[' + k + ']', String(v)); });
    Object.keys(order.files || {}).forEach(function (k) { (order.files[k] || []).forEach(function (f, i) { fd.append('properties[' + k + (i ? ' ' + (i + 1) : '') + ']', f); }); });
    fd.append('properties[_Order ref]', ref);
    var json = function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); };
    return fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } }).then(json).then(function () {
      var items = (order.addons || []).map(function (a) { return { id: a.variant.id, quantity: 1, properties: { 'For': order.title, '_Order ref': ref } }; });
      if (!items.length) return null;
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }).then(json);
    }).then(function () { window.location.href = cartUrl || '/cart'; });
  }

  /* Adds basket state + handler to a prototype component. buildOrder(logic) returns
     { order } or { error: 'message' }. */
  function withBasket(Base, buildOrder, extraVals) {
    class Shop extends Base {
      constructor(p) { super(p); this.state.busy = false; this.state.cartMsg = ''; this.state.cartMsgColour = '#181357'; }
    }
    Shop.prototype.renderVals = function () {
      var v = Base.prototype.renderVals.call(this), self = this, d = window.MelDC.data;
      v.busy = this.state.busy; v.cartMsg = this.state.cartMsg; v.cartMsgColour = this.state.cartMsgColour;
      v.homeUrl = d.urls.home; v.collUrl = d.urls.collection; v.contactUrl = d.urls.contact;
      v.addToBasket = function () {
        if (self.state.busy) return;
        var res;
        try { res = buildOrder(self, d); } catch (err) { res = { error: 'Sorry, something went wrong — please try again.' }; if (window.console) console.error(err); }
        if (res.error) { self.setState({ cartMsg: res.error, cartMsgColour: '#B42318' }); return; }
        self.setState({ busy: true, cartMsg: 'Adding to your basket…', cartMsgColour: '#181357' });
        addToCart(res.order, d.urls.cart).catch(function (err) {
          self.setState({ busy: false, cartMsg: (err && (err.description || err.message)) || 'Sorry, something went wrong — please try again.', cartMsgColour: '#B42318' });
        });
      };
      if (extraVals) extraVals(this, v, d);
      return v;
    };
    return Shop;
  }

  /* load a library script even when the page has an AMD/CommonJS loader that would otherwise swallow it */
  function loadScript(urls, globalName) {
    return new Promise(function (resolve, reject) {
      var i = 0;
      var next = function () {
        if (window[globalName]) return resolve(window[globalName]);
        if (i >= urls.length) return reject(new Error('Could not load ' + globalName));
        var saved = { define: window.define, module: window.module, exports: window.exports };
        try { window.define = undefined; window.module = undefined; window.exports = undefined; } catch (e) {}
        var s = document.createElement('script');
        s.src = urls[i++]; s.async = true;
        var done = function () { try { window.define = saved.define; window.module = saved.module; window.exports = saved.exports; } catch (e) {} };
        s.onload = function () { done(); if (window[globalName]) resolve(window[globalName]); else next(); };
        s.onerror = function () { done(); next(); };
        document.head.appendChild(s);
      };
      next();
    });
  }

  function showError(root, msg) {
    var box = root.querySelector('[data-mel-dc-status]');
    if (box) box.innerHTML = 'Sorry — the designer didn’t load. Please refresh the page, or email <a href="mailto:hello@myeventlab.co.uk">hello@myeventlab.co.uk</a>.<br><small style="opacity:.7">' + String(msg).replace(/[<>&]/g, '') + '</small>';
  }

  function addCss(css) {
    var st = document.createElement('style');
    st.setAttribute('data-mel-css', '');
    st.textContent = css;
    document.head.appendChild(st);
  }

  /* Sends an enquiry through Shopify's contact form, so it arrives in the store's email inbox.
     It is a real form post (not fetch) so Shopify's spam check can show if it needs to.
     fields: { Label: value }. The page reloads with ?contact_posted=true when it worked. */
  function enquiry(o) {
    o = o || {};
    var f = document.createElement('form');
    f.method = 'post'; f.action = '/contact#mel-sent'; f.acceptCharset = 'UTF-8'; f.style.display = 'none';
    var add = function (n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v == null ? '' : String(v); f.appendChild(i); };
    add('form_type', 'contact'); add('utf8', '✓'); add('return_to', location.pathname + '?contact_posted=true');
    add('contact[email]', o.email || '');
    if (o.name) add('contact[name]', o.name);
    if (o.phone) add('contact[phone]', o.phone);
    var lines = [o.subject || 'Website enquiry', 'Page: ' + location.href.split('?')[0], ''];
    Object.keys(o.fields || {}).forEach(function (k) { var v = o.fields[k]; if (v === '' || v == null || v === false) return; lines.push(k + ': ' + v); });
    add('contact[body]', lines.join('\n'));
    add('contact[Subject]', o.subject || 'Website enquiry');
    try { sessionStorage.setItem('mel-sent', location.pathname); } catch (e) {}
    document.body.appendChild(f);
    f.submit();
  }
  function sent() {
    var q = location.search;
    if (!/contact_posted=true/.test(q)) return false;
    try { return sessionStorage.getItem('mel-sent') === location.pathname; } catch (e) { return true; }
  }
  function validEmail(e) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e || '').trim()); }

  function boot(Logic, opts) {
    var started = Date.now();
    var run = function () {
      var root = document.querySelector('[data-mel-dc]');
      if (!root || root._melDc) return;
      if (!window.preact || !window.preact.h) {
        if (Date.now() - started > 12000) { showError(root, 'Preact not available'); return; }
        setTimeout(run, 60); return;
      }
      root._melDc = 1;
      try {
        var data = JSON.parse(document.getElementById('mel-dc-data').textContent);
        Object.keys(data.addons || {}).forEach(function (k) {
          var a = data.addons[k];
          if (a && a.variants) a.variants = a.variants.filter(function (v) { return v && v.id && typeof v.price === 'number'; });
          if (!a || !a.id || !a.variants || !a.variants.length) data.addons[k] = null;
        });
        if (data.product) data.product.variants = (data.product.variants || []).filter(function (v) { return v && v.id; });
        window.MelDC.data = data;
        var three = root.getAttribute('data-three');
        if (three && !window.THREE) loadScript(three.split(' '), 'THREE').catch(function () {});
        captureFiles(root);
        if (opts && opts.css) addCss(opts.css);
        var tpl = (opts && opts.tpl) || document.getElementById('mel-dc-tpl').textContent;
        mount(root, Logic, tpl, (opts && opts.props) ? opts.props(data) : {});
      } catch (err) {
        if (window.console) console.error('[MEL designer]', err);
        showError(root, err && err.message ? err.message : err);
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  }

  window.MelDC = { DCLogic: DCLogic, compile: compile, mount: mount, boot: boot, withBasket: withBasket, files: files,
    findVariant: findVariant, addonVariant: addonVariant, addToCart: addToCart, money: money, loadScript: loadScript, addCss: addCss, enquiry: enquiry, sent: sent, validEmail: validEmail, data: null };
  window.DCLogic = DCLogic;
})();
